import history from "../helpers/history";
import {store} from '../redux/store';
import Notifications from "react-notification-system-redux";
import {errorToNotifObj, getLSLang} from "../helpers";

import {getIdToken} from './auth';
import _ from 'lodash';
import axios from "axios";
import {ICompania} from "../redux/types/ICompania";
import {IEditUser, IRegisterUser, IUserAgente} from "../redux/types/IUser";
import {ICliente, IClienteFilter} from "../redux/types/ICliente";
import {IUsoMultiple} from "../redux/types/IUsosMultiples";
import {IRol} from "../redux/types/IRoles";
import {userLogout} from "../redux/reducers/authReducer";
import {INotificacionFilter} from "../redux/types/INotificacion";
import {IPharmacy, IPharmacyFilter} from "../redux/types/IPharmacy";
import {IPatient, IPatientFilter, IPrescription} from "../redux/types/IPatient";
import {IPolicyExchange, IPolicyExchangeFilter} from "../redux/types/IPolicyExchange";
import {IProduct, IProductFilter} from "../redux/types/IProduct";
import {ICategory, ICategoryFilter} from "../redux/types/ICategory";
import {IPurchase, IPurchaseFilter} from "../redux/types/IPurchase";
import {IMedicalSpeciality, IMedicalSpecialityFilter} from "../redux/types/IMedicalSpeciality";
import {IExchange, IExchangeFilter} from "../redux/types/IExchange";
import {IMedicalCenterFilter} from "../redux/types/IMedicalCenter";

let base_url = "https://acrobienestar.lagomac.com/api/";
// let base_url = "https://vivirmaxpr.acromax.com.do/api/";
// let base_url = "https://vivirmax.acromax.com.do/api/";

if(!window.location.origin.includes("localhost:3000")){
    base_url = window.location.origin+"/api/"
}

export {base_url};
export const API = axios.create({
    baseURL: base_url,
    // timeout: 1000,
    headers: { 'contentType': 'application/json; charset=utf-8', "accept-language": "es-US" }
})
API.interceptors.request.use(function (request) {
    const tokenId = getIdToken();
    request.headers["accept-language"] = getLSLang("l") === "en" ? "en-US" : "es-ES";
    request.headers["x-lang"] = getLSLang("l")
    // const decoded = jwt_decode(localStorage._token);
    //
    // const currentTime = Date.now() / 1000;
    // if(decoded.exp < currentTime) {
    //     store.dispatch(logoutUser());
    //     window.location.href = '/login'
    // }
    //
    if (tokenId) request.headers.Authorization = `Bearer ${tokenId}`;

   // if (!window.navigator.onLine) alert("no estas conectado a internet");
    return request;
})
API.interceptors.response.use(function (response) {
    //notificaciones en redux
    let reduxNot = ["getsolicitudes","marcarleida", "comunesenviarcorreo","enviarcorreo","exchanges"];
    // let url = response.config.url?.replaceAll("/","").toLowerCase();

    // if(!!url && !reduxNot.includes(url)){
    let url = response.config.url?.toLowerCase();

    if (!reduxNot.some(i=> url?.includes(i))) {

        let msj = "";
        switch (response.config.method) {
            case "post":
                msj = "Registro guardado";
                break
            case "put":
                msj = "Registro actualizado";
                break
            case "delete":
                msj = "Registro eliminado";
                break
            default:
                msj = "";
        }
        if (msj)
            store.dispatch(Notifications.success({title: msj + ' con exito.', autoDismiss: 4}));
    }
    return response;
}, function (error) {
    if (error.response) {
        if (error.response.status === 401) {
           // localStorage.removeItem('_token');
            if (history.location.pathname.indexOf("/report") !== -1) {
                window.close();
            }
          //  history.replace("/login", { backurl: history.location.pathname })
            store.dispatch(userLogout())
        } else if (error.response.status === 403) {
            store.dispatch(Notifications.warning({ title: 'Acceso denegado', message: 'Necesita permisos para realizar esta acción.', autoDismiss: 5 }));
        } else {
            store.dispatch(Notifications.error(errorToNotifObj(error?.response?.data)));
        }
    }
    return Promise.reject(error);
});
export const API_PUBLIC = axios.create({
    baseURL: base_url,
    headers: { 'contentType': 'application/json; charset=utf-8', "accept-language": "en-US" }
})
API_PUBLIC.interceptors.request.use(function (request) {
    // request.headers["accept-language"] = getLSLang("l") === "en" ? "en-US" : "es-ES";
    // request.headers["x-lang"] = getLSLang("l")
    return request;
})

export const API_PORTAL_CLIENTE = axios.create({
    baseURL: base_url,
    headers: { 'contentType': 'application/json; charset=utf-8', "accept-language": "en-US" }
})
API_PORTAL_CLIENTE.interceptors.request.use(function (request) {
    if(!request.url?.toLowerCase().includes("login")) {
        let tokenId = localStorage.getItem("cliToken");
        if(tokenId) request.headers.Authorization = "Bearer "+tokenId;
    }
    return request;
})

//Purchases
export function getPurchases(filter?:IPurchaseFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`Purchases/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("Purchases", { params });
    }
}
export function addEditPurchase(obj:IPurchase) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Purchases/'+obj.id, params): API.post('Purchases', params);
}
export function delPurchase(id:number) {
    return API.delete(`Purchases/${id}`);
}
export function changeStatusPurchase(obj:IPurchase) {
    let params = _.omitBy(obj, (v) => !v);

    return API.post(`Purchases/${params.id}/ChangeStatus`, params);
}
export function removeApprovalPurchase(id:number) {
    return API.post(`Purchases/${id}/RemoveApproval`);
}
//Exchanges
export function getExchanges(filter?:IExchangeFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`Exchanges/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("Exchanges", { params });
    }
}
export function getExchangeByCode(code:string) {
    return API.get("Exchanges/GetByCode", { params: {code} });

}
export function addEditExchange(obj:IExchange) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Exchanges/'+obj.id, params): API.post('Exchanges', params);
}
export function delExchange(id:number) {
    return API.delete(`Exchanges/${id}`);
}
export function changeStatusExchange(obj:IExchange) {
    let params = _.omitBy(obj, (v) => !v);

    return API.post(`Exchanges/${params.id}/ChangeStatus`, params);
}
export function changeStatusExchangeByCode(obj:IExchange) {
    let params = _.omitBy(obj, (v) => !v);

    return API.post(`Exchanges/AprovalByCode`, params);
}
export function removeApprovalExchange(id:number) {
    return API.post(`Exchanges/${id}/RemoveApproval`);
}
//Pharmacies
export function getPharmacies(filter?:IPharmacyFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`Pharmacies/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("Pharmacies", { params });
    }
}
export function addEditPharmacy(obj:IPharmacy) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Pharmacies/'+obj.id, params): API.post('Pharmacies', params);
}
export function delPharmacy(id:number) {
    return API.delete(`Pharmacies/${id}`);
}
export function generatePharmacyUser(id:number) {
    return API.post(`Pharmacies/${id}/GenerateUser`);
}

//Patients
export function getPatients(filter?:IPatientFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`Patients/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("Patients", { params });
    }
}
export function addEditPatient(obj:IPatient) {
    let params = _.omitBy(obj, (v) => !v);
    // if(params.medicalSpeciality && !params.medicalSpecialityId){
    //     params.medicalSpecialityId = null
    // }
    return obj.id ? API.put('Patients/'+obj.id, params): API.post('Patients', params);
}
export function delPatient(id:number) {
    return API.delete(`Patients/${id}`);
}

export function generatePatientUser(id:number) {
    return API.post(`Patients/${id}/GenerateUser`);
}


export function addPrescription(obj:IPrescription) {
    let params = _.omitBy(obj, (v) => !v);
    return  API.post('Prescriptions', params);
}
export function delPrescription(id:number) {
    return  API.delete('Prescriptions/'+id);
}




//PolicyExchanges
export function getPolicyExchanges(filter?:IPolicyExchangeFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`PolicyExchanges/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("PolicyExchanges", { params });
    }
}
export function addEditPolicyExchange(obj:IPolicyExchange) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('PolicyExchanges/'+obj.id, params): API.post('PolicyExchanges', params);
}
export function delPolicyExchange(id:number) {
    return API.delete(`PolicyExchanges/${id}`);
}

//Products
export function getProducts(filter?:IProductFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`Products/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("Products", { params });
    }
}
export function addEditProduct(obj:IProduct) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Products/'+obj.id, params): API.post('Products', params);
}
export function delProduct(id:number) {
    return API.delete(`Products/${id}`);
}
//MedicalSpecialities
export function getMedicalSpecialities(filter?:IMedicalSpecialityFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`MedicalSpecialities/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("MedicalSpecialities", { params });
    }
}
export function addEditMedicalSpeciality(obj:IMedicalSpeciality) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('MedicalSpecialities/'+obj.id, params): API.post('MedicalSpecialities', params);
}
export function delMedicalSpeciality(id:number) {
    return API.delete(`MedicalSpecialities/${id}`);
}

export function getMedicalCenters(filter?: IMedicalCenterFilter) {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("MedicalCenters", { params });
}

//Categories
export function getCategories(filter?:ICategoryFilter|number) {
    if (typeof filter === 'number') {
        return API.get(`Categories/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("Categories", { params });
    }
}
export function addEditCategory(obj:ICategory) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Categories/'+obj.id, params): API.post('Categories', params);
}
export function delCategory(id:number) {
    return API.delete(`Categories/${id}`);
}


//Compania
export function getCompanias() {
    return API.get('Companias');
}
export function editCompanias(obj:ICompania) {
    let params = _.omitBy(obj, _.isNil);
    return API.put('Companias', params);
}


//perfil
export function getPerfil() {
    return API.get('Auth/Profile');
}
export function ediPerfil(obj:IEditUser) {
    let params = _.omitBy(obj, (v) => !v);
    return API.put('Auth/Profile', params);
}


//DashBoard

export function getWidgets(rutaId?:number) {
    return API.get('/Reportes/Dashboard',{ params: rutaId? { rutaId }:{} });
}
export function getWidgetsGasIng(ciclo?:number,rutaId?:number) {
    return API.get('/Reportes/ResumenIngresos', { params: { ciclo,rutaId } });
}
export function getResumenGrafico(year:number = new Date().getFullYear(), rutaId?:number) {
    return API.get(`/Reportes/ResumenGrafico`, { params: { year,rutaId } });
}

//Clientes
export function getClientes(filter?:IClienteFilter|number, simpleObj?:boolean) {
    if (typeof filter === 'number') {
        return API.get(`Clientes/${filter}`)
    } else {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get(simpleObj ? "Clientes/ListadoSimple" : "Clientes", { params });
    }
}
export function addEditCliente(obj:ICliente) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Clientes/'+obj.id, params): API.post('Clientes', params);
}
export function delCliente(id:number) {
    return API.delete(`Clientes/${id}`);
}

export function rateCliente(params:{ id: number, rate: number }) {
    return API.post(`/clientes/${params.id}/calificar`, params);
}


//Agente
export function getAgentes(filter?:{name?:string}) {
        let params = _.omitBy(filter, (v) => v === '' || _.isNil(v));
        return API.get("Users", { params });
}
export function getAgenteById(id:number) {
    return API.get(`Users/${id}`)
}
export function addEditAgente(obj:IUserAgente) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Users/'+obj.id, params): API.post('Users', params);
}

export function editPWAgente(params:{ id: number, newPassword: string }) {
    return API.post(`Users/${params.id}/ChangePassword`, params);
}
export function delAgente(id:number) {
    return API.delete(`Users/${id}`);
}
export function lockToggleAgente(id:number) {
    return API.post(`Users/${id}/Inactive`);
}


export function getUsosMultiples(params?:{name?:string, tipo?:number}) {
    return API.get('UsosMultiples', { params });
}
export function addEditUsosMultiple(obj:IUsoMultiple) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('UsosMultiples/'+params.tipo, {id:params.id, descripcion:params.descripcion}): API.post('UsosMultiples', params);
}

export function delUsosMultiple(id:number) {
    return API.delete('UsosMultiples/'+id);
}






//Roles
export function getRoles(id?:number) {

    if (typeof id == 'number') {
        return API.get(`Roles/${id}`);
    }

    return API.get('Roles');

}
export function getRolById(id:number) {
    return API.get(`Roles/${id}`);
}
export function addEditRol(obj:IRol) {
    let params = _.omitBy(obj, (v) => !v);
    return obj.id ? API.put('Roles/'+obj.id, params): API.post('Roles', params);
}

export function delRol(id:number) {
    return API.delete(`Roles/${id}`);
}

//permisos
export function getPermisos() {
    return API.get('RolesPermissions/GetAll');
}

//Countries
export function getCountries(name: string ) {
    return API.get('Countries', {params: {name, pageSize: 100}});
}
//Cities
export function getCities(name: string ) {
    return API.get('Cities', {params: {name, pageSize: 100}});
}

//Configurations
export function getConfigurationsParameters() {
    return API.get('Configurations/Parameters');
}
export function editConfigurationsParameters(parameters:number[]) {
    return API.put('Configurations/Parameters', {parameters});
}
//comunes
export function getEnums() {
    return API.get('comunes/Enums');
}
export function getIndicadoresMenu() {
    return API.get('comunes/indicadoresMenu');
}
export function consultarPadron(dni:string) {
    return API.get('/Comunes/ConsultarPadron?dni='+dni);
}

//notificaciones
export function getNotificaciones(obj:INotificacionFilter) {
    let params = _.omitBy(obj, (v) => !v);
    return API.get('Notificaciones',{params});
}
export function readNotificacion(id:string) {
    return API.post('Notificaciones/'+id+'/MarcarLeida');
}
export function delNotificacion(id:string) {
    return API.delete('Notificaciones/'+id);
}
//amort



//auth
export function PostRegister(obj:IRegisterUser, validar?:boolean) {
    let params = _.omitBy(obj, (v) => !v);
    return API_PUBLIC.post('/Auth/Register', {...params, validar: !!validar});
}
export function deleteAccount(motivo?:string) {
    return API.post('/Auth/Unsuscription', {motivo});
}
export function changePassword(params:{ oldPassword: string, newPassword: string }) {
    return API.post('/Auth/ProfileChangePassword', params);
}
export function forgotPassword(email:string) {
    return API.post('Auth/ForgotPassword', {email});
}
export function forgotPasswordConfirm(code: string, password: string) {
    return API.post('Auth/ForgotPasswordConfirm', {code,password});
}
